import { SITE } from '@/app/constants';

const BASE =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset'
    : 'https://image01.cf.vidu.studio/vidu/media-asset';

// Hero 视频：R1 专属素材，暂放本地 public/videos，上线前需转到 CDN。
export const HERO_VIDEO_POSTER = '/videos/r1-hero-poster.jpg';
export const HERO_VIDEO_SRC = '/videos/r1-hero.mp4';
export const HERO_VIDEO_MOBILE_SRC = '/videos/r1-hero.mp4';

// 轮播第二、三、四张卡视频：同为本地占位，待转 CDN。
export const CARD2_VIDEO_POSTER = '/videos/r1-card-2-poster.jpg';
export const CARD2_VIDEO_SRC = '/videos/r1-card-2.mp4';
export const CARD3_VIDEO_POSTER = '/videos/r1-card-3-poster.jpg';
export const CARD3_VIDEO_SRC = '/videos/r1-card-3.mp4';
export const CARD4_VIDEO_POSTER = '/videos/r1-card-4-poster.jpg';
export const CARD4_VIDEO_SRC = '/videos/r1-card-4.mp4';

// 模型家族配图：复用 vidu-stream feature 图占位，待换成各模型的真实主视觉。
export const MODEL_IMAGES = {
  r1: `${BASE}/feature-1-characters-476b8061.webp`,
  s1: `${BASE}/feature-3-custom-9714a037.webp`,
};

// 最新动态卡片配图：复用 vidu-stream feature 图占位，待换成各条动态的真实封面。
export const NEWS_IMAGES = [
  `${BASE}/feature-1-characters-476b8061.webp`,
  `${BASE}/feature-2-voice-0e82197a.webp`,
  `${BASE}/feature-3-custom-9714a037.webp`,
  `${BASE}/feature-4-unlimited-0bd8acf5.webp`,
];
